import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
// import { createLogger } from "redux-logger";

// const logger = createLogger();

import rootReducer from "./rootReducer";
import storePersist from "./storePersist";

let middleware = [thunk];

let configStore = applyMiddleware(...middleware);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

if (process.env.NODE_ENV === "development") {
  configStore = composeEnhancers(applyMiddleware(...middleware));
}

const initialState = storePersist.get("auth")
  ? { auth: storePersist.get("auth") }
  : {};

const store = createStore(rootReducer, initialState, configStore);

export default store;
